<!-- 
Notices listing page.
-->
<template>
  <div class="home">
    <our-heading
      :breadcrumbs="breadcrumbs"
      title="Notices"
      user-guide-topic="listing-notices"
    />
    <our-search-bar>
      <our-quick-search 
        slot="quick-search"
        :criteria-mutation="criteriaMutation" 
        :value="quickSearch"
        label="Provider name or code" 
        field="providerName" 
        field-if-numeric="providerCode" 
        @changed="$refs.notices.refresh()"
      />
      <our-search-button 
        slot="search-button"
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search notices"
        show-all
        @changed="$refs.notices.refresh()"
      />
      <our-saved-searches-menu
        slot="saved-searches-button"
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="notices" 
        @selected="$refs.notices.refresh()"
      />
    </our-search-bar>
    <notice-listing ref="notices" @changed="$refs.notices.refresh()"/>
  </div>
</template>

<script>
import * as mutation from "@/store/notices/mutation-types";
import NoticeListing from "@/components/notices/NoticeListing.vue";
import { getSearchFilters } from "@/store/notices/helpers";

export default {
  name: "Notices",
  components: {
    NoticeListing
  },
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA,
      breadcrumbs: [{ text: "Notices" }]
    };
  },
  computed: {
    criteria() {
      return this.$store.state.notices.listing.criteria;
    },
    searchFilters() {
      return getSearchFilters();
    },
    quickSearch() {
      return this.criteria.providerCode && !this.criteria.providerName
        ? this.criteria.providerCode
        : this.criteria.providerName;
    }
  }
};
</script>
